import { fabric } from 'fabric'

const mixin = {
  methods: {
    createFabricText (text, textHeight, additional) {
      const fontSize = Math.floor(textHeight)
      const fontFamily = 'Roboto'
      const fill = 'rgb(200,200,200)'
      const properties = {
        fontSize,
        fontFamily,
        fill,
        selectable: false,
        evented: false
      }
      return new fabric.Text(text, Object.assign(properties, additional))
    },

    createTexts () {
      const { rowHeights, padding, ys } = this.canvasDimensions
      const textHeight = rowHeights.text
      const secondaryTextHeight = rowHeights.secondaryText
      const hPadding = padding * 4
      const top = ys.text
      const secondaryTextTop = ys.secondaryText

      const createFrameText = () => this.createFabricText(
        '',
        textHeight,
        {
          top
        })
      const createTimeText = () => this.createFabricText(
        '',
        secondaryTextHeight,
        {
          top: secondaryTextTop
        })

      const startFrameText = createFrameText()
      startFrameText.left = hPadding
      const centerFrameText = createFrameText()
      const endFrameText = createFrameText()
      const startTimeText = createTimeText()
      startTimeText.left = hPadding
      const centerTimeText = createTimeText()
      const endTimeText = createTimeText()

      this.canvasTexts = {
        frame: {
          start: startFrameText,
          center: centerFrameText,
          end: endFrameText
        },
        time: {
          start: startTimeText,
          center: centerTimeText,
          end: endTimeText
        }
      }

      this.addToCanvas(this.canvasTexts.frame)
      this.addToCanvas(this.canvasTexts.time)
    },

    updateFrameTimeTexts () {
      const { minFrame, maxFrame, minTime, maxTime, cursorFrame, cursorTime } = this.frameTimeTextCache
      const { start: frameStart, center: frameCenter, end: frameEnd } = this.canvasTexts.frame
      const { start, center, end } = this.canvasTexts.time

      const { padding, width } = this.canvasDimensions
      const hPadding = padding * 4
      const canvasPanX = this.canvas.viewportTransform[4]
      const left = hPadding - canvasPanX
      const right = width - hPadding - canvasPanX

      // TODO Set delta (if not zero) so text doesn't wobble during canvas panning
      frameStart.text = minFrame
      frameStart.left = left
      frameStart.setCoords()

      frameEnd.text = maxFrame

      start.text = minTime
      end.text = maxTime

      frameCenter.text = cursorFrame || ''
      center.text = cursorTime || ''

      const updateEndText = () => {
        end.left = right - end.width
        frameEnd.left = end.left - hPadding - frameEnd.width
        end.setCoords()
        frameEnd.setCoords()
      }

      window.requestAnimationFrame(() => {
        start.left = Math.ceil(frameStart.left + frameStart.width + hPadding)
        start.setCoords()

        updateEndText()
        if (end.width < 10 || frameEnd.width < 10) {
          // End frame texts need additional time to compute correct size when becoming visible
          setTimeout(() => {
            updateEndText()
            this.canvas.requestRenderAll()
          }, 9)
        }

        if (cursorFrame) {
          const middle = (left + right) * 0.5
          const framePaddingWidth = frameCenter.width + hPadding
          const centerTextWidth = (framePaddingWidth + center.width)
          frameCenter.left = middle - centerTextWidth * 0.5
          center.left = frameCenter.left + framePaddingWidth
          frameCenter.setCoords()
          center.setCoords()
        }

        this.canvas.requestRenderAll()
      })
    }
  }
}

export default mixin
